var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 18.333H1.66669C1.32502 18.333 1.04169 18.0497 1.04169 17.708C1.04169 17.3663 1.32502 17.083 1.66669 17.083H18.3334C18.675 17.083 18.9584 17.3663 18.9584 17.708C18.9584 18.0497 18.675 18.333 18.3334 18.333Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.33366V18.3337H11.875V3.33366C11.875 2.41699 11.5 1.66699 10.375 1.66699H9.625C8.5 1.66699 8.125 2.41699 8.125 3.33366Z",
    fill: "#CBD5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M2.5 8.33366V18.3337H5.83333V8.33366C5.83333 7.41699 5.5 6.66699 4.5 6.66699H3.83333C2.83333 6.66699 2.5 7.41699 2.5 8.33366Z",
    fill: "#CBD5E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.1667 12.4997V18.333H17.5V12.4997C17.5 11.583 17.1667 10.833 16.1667 10.833H15.5C14.5 10.833 14.1667 11.583 14.1667 12.4997Z",
    fill: "#CBD5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart-bar.279115cbb5d086e9ba5fe22a70ad4dba.svg";
export { ForwardRef as ReactComponent };